import React from 'react';
import type { ITextElement, Token } from '@basis-theory/react-elements';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';

import { type OnboardingState } from './onboardingReducer';
import {
  BasisTheoryTextElement,
  OnboardingDropdown,
  OnboardingToggle,
} from './SharedUI';

const OWNERSHIP_TYPE_OPTIONS = [
  { value: 'sole_proprietorship', label: 'Sole Proprietorship' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'llc', label: 'LLC' },
  { value: 'corporation', label: 'Corporation' },
  { value: 's_corporation', label: 'S Corporation' },
  { value: 'nonprofit', label: 'Nonprofit' },
];

type IncorporationViewProps = {
  onboardingState: OnboardingState;
  setOnboardingField: (
    stateKey: string,
    value: string | string[] | boolean | { type: string; number: string }[]
  ) => void;
  token: Token | null;
  updateToken: (id: string, ref: React.RefObject<ITextElement>) => void;
  isDarkMode: boolean;
  onNext?: () => void;
};

export const IncorporationView = ({
  onboardingState,
  setOnboardingField,
  token,
  updateToken,
  isDarkMode,
  onNext,
}: IncorporationViewProps) => (
  <div className="flex flex-col h-fit gap-y-f2">
    <BasisTheoryTextElement
      id="businessEin"
      label="Employer Identification Number (EIN)"
      token={token}
      update={updateToken}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="businessStateOfIncorporation"
      label="State of Incorporation"
      token={token}
      update={updateToken}
      isDarkMode={isDarkMode}
    />
    <BasisTheoryTextElement
      id="businessYearIncorporated"
      label="Year of Incorporation"
      token={token}
      update={updateToken}
      isDarkMode={isDarkMode}
    />
    <OnboardingDropdown
      stateKey="structure"
      label="Ownership Type"
      options={OWNERSHIP_TYPE_OPTIONS}
      state={onboardingState}
      setField={setOnboardingField}
    />
    <OnboardingToggle
      label="Has your company undergone any significant changes to its legal structure, ownership (>25%), name, or jurisdiction of incorporation in the past 24 months?"
      stateKey="hasUndergoneSignificantChanges"
      state={onboardingState}
      setField={setOnboardingField}
    />
    {onNext != null && <PrimaryButtonV2 onClick={onNext}>Next</PrimaryButtonV2>}
  </div>
);
